import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import ServicePage from "./Pages/ServicePage";
import PricingPage from "./Pages/PricingPage";
import ContactUs from './Pages/ContactUs';
import ThankYou from './Components/ThankYou';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Specialities from "./Components/Specialities";
import Notfound from "./Components/notfound";
import TermsConditions from "./Components/terms&conditions";
import PrivacyPolicy from "./Components/privacy";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: 'Orig Graphik, sans-serif',
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: {
            '&.Mui-focused': {
              color: '#f28c38', // Orange label on focus
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#00a6a2', // thickGreen border on focus
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path=":serviceName" element={<ServicePage />} />
          <Route path="/our-medical-services" element={<Specialities />} />
          <Route path="/laboratory-services-in-hospital" element={<PricingPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Notfound />} />

          {/*  Redirects from old URLs to new ones */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<Navigate to="/about-us" replace />} />
          <Route path="/tour" element={<Navigate to="/about-us" replace />} />
          <Route path="/tNc" element={<Navigate to="/terms-and-conditions" replace />} />
          <Route path="/contactUs" element={<Navigate to="/contact-us" replace />} />
          <Route path="/privacypolicy" element={<Navigate to="/privacy-policy" replace />} />
          <Route path="/internal-medicine" element={<Navigate to="/general-medicine" replace />} />
          <Route path="/pediatrics-neonatology" element={<Navigate to="/best-pediatrics-hospitals" replace />} />
          <Route path="/anaesthesia-painManagement" element={<Navigate to="/anesthesia-and-pain-management" replace />} />
          <Route path="/dermatology-aestheticMedicine" element={<Navigate to="/best-dermatologist-in-hyderabad" replace />} />
          <Route path="/neurology" element={<Navigate to="/neurologist-in-hyderabad" replace />} />
          <Route path="/oncology" element={<Navigate to="/medical-oncology" replace />} />
          <Route path="/neprology" element={<Navigate to="/nephrology-hospital" replace />} />
          <Route path="/pulmonology" element={<Navigate to="/best-pulmonology-hospital-hyderabad" replace />} />
          <Route path="/critical-care" element={<Navigate to="/critical-care-medicine" replace />} />
          <Route path="/cardiology" element={<Navigate to="/cardiology-hospitals-in-hyderabad" replace />} />
          <Route path="/psychiatry" element={<Navigate to="/best-psychiatrist-in-hyderabad" replace />} />
          <Route path="/gastroenterology" element={<Navigate to="/best-gastroenterologist-in-hyderabad" replace />} />
          <Route path="/orthopedics" element={<Navigate to="/hyderabad-orthopedic-hospital" replace />} />
          <Route path="/ent" element={<Navigate to="/ent-hospital-in-hyderabad" replace />} />
          <Route path="/surgical-gastroenterology" element={<Navigate to="/gastrology-surgery" replace />} />
          <Route path="/omfs" element={<Navigate to="/omfs-surgeon" replace />} />
          <Route path="/obstetrics-gynaecology" element={<Navigate to="/best-gynecologist-in-hyderabad" replace />} />
          <Route path="/urology" element={<Navigate to="/best-urologist-in-hyderabad" replace />} />
          <Route path="/spine-surgery" element={<Navigate to="/spine-surgery-hospitals" replace />} />
          <Route path="/surgical-oncology" element={<Navigate to="/cancer-hospital-in-hyderabad" replace />} />
          <Route path="/plastic-cosmetic-surgery" element={<Navigate to="/plastic-surgery" replace />} />
          <Route path="/paediatric-surgery" element={<Navigate to="/best-pediatric-surgeon-in-hyderabad" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;